/* eslint-disable max-len */
import { Button } from '@dasa-health/components-react'
import React, { useState } from 'react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { ModalDataContainer } from '../style'

export const WhyCantEditModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button
                    borderRadius="pill"
                    onClick={() => setIsOpen(true)}
                    size="compact"
                    sx={{ paddingLeft: 0, marginY: '0.75rem' }}
                    type="button"
                    variant="tertiary"
                >
                    Por que não consigo alterar meus dados?
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        title="Porque não posso alterar meus dados na tela?"
                    >
                        <p>
                            As informações de CPF, nome legal e data de nascimento estão atreladas ao registro oficial na Receita
                            Federal.
                        </p>
                        <p>Você pode editar suas informações na área de Dados Cadastrais do aplicativo.</p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
